<template>
  <div class="app">
    <h1>Pokémon Directory</h1>
    <SearchBox v-model="query" placeholder="ポケモン名で検索（例: アブソル, ピカチュウ）" />
    <button class="reload" @click="reload">Reload</button>
    <div v-if="loading">Loading...</div>
    <div v-else>
      <p v-if="filtered.length === 0">該当なし</p>
      <ul class="list" role="list">
        <li v-for="(p, idx) in filtered" :key="p._key" class="card" role="listitem">
          <div class="meta">
            <div class="name" :title="p.name">{{ p.name }}</div>
            <small class="id" v-if="p.id">ID: {{ p.id }}</small>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SearchBox from './components/SearchBox.vue'

export default {
  components: { SearchBox },
  data() {
    return {
      list: [],
      loading: true,
      query: ''
    }
  },
  computed: {
    filtered() {
      const q = this._normalizeQuery(this.query)
      if (!q) return this.list
      return this.list.filter(p => {
        const name = (p.name || '').toLowerCase()
        const id = String(p.id || '').toLowerCase()
        return name.includes(q) || id.includes(q)
      })
    }
  },
  methods: {

    _normalizeQuery(s) {
      return (s || '').replace(/\u3000/g, ' ').trim().toLowerCase()
    },
    _buildKey(x) {
      const id = String(x && x.id != null ? x.id : '').trim()
      const name = String(x && x.name != null ? x.name : '').trim()
      return `${id}::${name}`
    },

    normalizeList(raw) {
      if (Array.isArray(raw)) return raw
      if (raw && Array.isArray(raw.data)) return raw.data
      return []
    },
    async reload() {
      this.loading = true
      try {
        const res = await this.$http.get('/api/pokemon', { headers: { 'Cache-Control': 'no-cache' } })
        const arr = this.normalizeList(res.data)
        this.list = arr.map(x => ({
          id: String(x && x.id != null ? x.id : ''),
          name: String(x && x.name != null ? x.name : ''),
          _key: this._buildKey(x),
          image_url: x && x.image_url ? x.image_url : null
        }))
      } catch (e) {
        console.error('[reload] /api/pokemon failed:', e && e.message)
        this.list = []
      } finally {
        this.loading = false
      }
    },
    fallback(id) {
      return `/images/pokemon/${id || 'noimg'}.png`
    },
    onImgErr(e) {
      const el = e.target
      if (el && !el.dataset._errored) {
        el.dataset._errored = '1'
        el.src = '/images/noimg.png'
      }
    }
  },
  async created() {
    await this.reload()
  }
}
</script>

<style>
/* Base */
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans JP", "Hiragino Kaku Gothic ProN",
    "Meiryo", sans-serif;
  margin: 0;
  padding: 16px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.app h1 { margin-top: 0; }
.reload { margin-bottom: 8px; }

/* Flex list: stable wrapping */
.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-content: flex-start;
}

/* Fixed card box for stability */
.card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 12px;
  width: 260px;
  height: 88px;    /* single-line name + ID fits */
  overflow: hidden;
  box-sizing: border-box;
}

/* Text column */
.meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

/* Name: single line, ellipsis (no flicker) */
.name {
  line-height: 18px;
  height: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-word;
  overflow-wrap: anywhere;
  font-weight: 600;
}

/* ID row (optional) */
.id {
  line-height: 18px;
  margin-top: 4px;
  opacity: 0.75;
}
</style>
